<ol class="breadcrumb">
  <li>
    <a routerLink="/home">
      <i class="icon-home"></i> Home</a>
    </li>
    <li>
      @if (iodFlag) {
        {{selectedOption}}
      }
    </li>
  </ol>
  <h1>
    @if (iodFlag) {
      {{selectedOption}}
    }
  </h1>
  <p class="note">*Click on the report id to view details</p>

  @if (((selectedList$ | async) === 'myreports')) {
    <a href="https://cers.aa.com/#/reporthistory/myreports" target="_blank">Click here if a report you submitted is
    not listed.</a>
    <br>
      <p>CERS is transitioning websites. Not all report types are viewable here.</p>
    }

    @if (((selectedList$ | async) === 'allreports')) {
      <a href="https://cers.aa.com/#/reporthistory/allreports" target="_blank">Click here if a report is not
      listed.</a>
      <br>
        <p>CERS is transitioning websites. Not all report types are viewable here.</p>
      }

      <div class="row">
        <div class="col-lg-12">
          @if (!iodFlag) {
            <div class="btn-div">
              <button class="btn-myreports" [ngClass]="{'selected-report':((selectedList$ | async) === 'myreports')}" (click)="displayReports('myreports')">My reports</button>
            </div>
            <div class="btn-div">
              @if (isReportManagementAccess) {
                <button class="btn-myreports" [ngClass]="{'selected-report':((selectedList$ | async) === 'allreports')}" (click)="displayReports('allreports')">All reports</button>
              }
            </div>
          }
          <div class="btn-div cognoslink">
            @if (isReportManagementAccess && ((selectedList$ | async) === 'allreports')) {
              <span class="">
                <a target="_blank" href="{{cognosUrl}}">Cognos Advanced Search</a>
                <i class="icon-newpage" aria-hidden="true"></i>
              </span>
            }
          </div>
          @if (((selectedList$ | async) === 'myreports')) {
            <app-table-my-reports [employeeId]=employeeId>My reports
            </app-table-my-reports>
          }
          @if (((selectedList$ | async) === 'allreports') && isReportManagementAccess) {
            <app-table-all-reports [employeeId]=employeeId [isReportManagementAccess]=isReportManagementAccess>All reports
            </app-table-all-reports>
          }
        </div>
      </div>
